import React from 'react'

import { templateVideoStyle } from './styles'

export const Video = props => {
  const { classes } = props

  return (
    <div
      className={classes.container}
      style={templateVideoStyle(props.device, props.received)}>
      <video src={props.url} width="100%" height="100%" controls>
        Your browser does not support the video tag.
      </video>
    </div>
  )
}
